import { useSelector } from "react-redux";
import { defaultHackerAllSelector } from "store/bailiff/(default)/hacker/default_hacker.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useActionHackerRefine = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(defaultHackerAllSelector);
  const total = data?.length || 0;
  console.log({ total });
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data, total };
};
